import {ModelApi} from '@/api/model.api.js'

/**
 * Timezones API service
 */
export class TimezonesApi extends ModelApi {

  //Props
  basePath = '/timezones'
  itemsKey = 'timezones'
}

//Export singleton instance
export const timezonesApi = new TimezonesApi()
